var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Video = function SvgAv5Video(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "icon-with-background"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon-background",
    y: 1.5,
    width: 16,
    height: 13,
    fill: "#002774"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "inner-vectors",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.5H16M.5 13.5H16",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6,6 6,10 10,8",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }))));
};
export { SvgAv5Video as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS12YXJpYW50PSJpY29uLXdpdGgtYmFja2dyb3VuZCI+CiAgICA8cmVjdCBjbGFzcz0iaWNvbi1iYWNrZ3JvdW5kIiB5PSIxLjUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMyIgZmlsbD0iIzAwMjc3NCIvPgogICAgPGcgY2xhc3M9ImlubmVyLXZlY3RvcnMiPgogICAgICAgIDxwYXRoIGQ9Ik0uNSwyLjUgTDE2LDIuNSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1kYXNoYXJyYXk9IjEiLz4KICAgICAgICA8cGF0aCBkPSJNLjUsMTMuNSBMMTYsMTMuNSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1kYXNoYXJyYXk9IjEiLz4KICAgICAgICA8cG9seWdvbiBwb2ludHM9IjYsNiA2LDEwIDEwLDgiIGZpbGw9IiNmZmYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMC42IiBzdHJva2U9IiNmZmYiLz4KICAgIDwvZz4KPC9zdmc+";